import { STAT_MAPPINGS, RATING_STAT_KEYS } from './statsMapping';
import { formatPercentile, getPercentileViewLabels } from './percentiles';

function cell(value) {
  let text = value == null ? '' : String(value);
  if (typeof value === 'string' && /^[\s]*[=+@-]/.test(text)) text = `'${text}`;
  return `"${text.replace(/"/g, '""')}"`;
}

export function convertToCSV(data, selectedStats, statisticsMetadata = {}, showPercentiles = false, groupLabels = {}) {
  const stats = selectedStats.filter(key => STAT_MAPPINGS[key]);
  const headers = ['Group'];
  const includeCourseCodes = Object.keys(data).some(group => groupLabels[group]?.tooltip);
  if (includeCourseCodes) headers.push('Course codes');
  for (const stat of stats) {
    const label = STAT_MAPPINGS[stat];
    headers.push(label);
    if (RATING_STAT_KEYS.includes(stat)) {
      headers.push(`${label} — absolute score (1–5)`, `${label} — percentile`, `${label} — response count`,
        `${label} — sample standard deviation (1–5 ratings)`, `${label} — benchmark years`, `${label} — percentile population`, `${label} — percentile weighting`, `${label} — percentile note`);
    }
  }
  const rows = [headers];
  for (const [group, values] of Object.entries(data)) {
    const row = [groupLabels[group]?.label || group];
    if (includeCourseCodes) row.push(groupLabels[group]?.tooltip || '');
    for (const stat of stats) {
      const details = statisticsMetadata[group]?.[stat] || {};
      const value = values[stat];
      const rating = RATING_STAT_KEYS.includes(stat);
      const percentile = Number.isFinite(details.percentile) ? formatPercentile(details.percentile) : null;
      row.push(rating && showPercentiles ? percentile ?? 'N/A' : typeof value === 'number' ? value.toFixed(2) : value ?? 'N/A');
      if (rating) {
        const professor = details.percentile_population === 'professor';
        const { population, weighting } = getPercentileViewLabels(!professor, professor);
        const weightLabel = details.percentile_weighted_by_class_size ? weighting : `equal ${professor ? 'professor' : 'course'} weights`;
        row.push(details.mean ?? value, percentile !== null ? `${percentile} percentile` : '', details.n ?? '', details.std ?? '',
          details.benchmark_years ?? '', population[0].toUpperCase() + population.slice(1), weightLabel[0].toUpperCase() + weightLabel.slice(1),
          [details.percentile_reason, stat === 'workload' ? 'Higher percentile means heavier reported workload, not a better score.' : null].filter(Boolean).join(' '));
      }
    }
    rows.push(row);
  }
  return rows.map(row => row.map(cell).join(',')).join('\r\n');
}
